<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formFreight">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteFreight()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="freightContract.userNameCreate"
              [createDate]="freightContract.createDate" [userNameUpdate]="freightContract.userNameUpdate"
              [updateDate]="freightContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-between">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-5 fieldset-freight">
              <p-fieldset legend="Origen">
                <div class="d-flex flex-wrap gap-1">
                  <div class="col field-city-origin">
                    <app-custom-inputgroup [inputValue]="cityOrigin" [labelText]="'Ciudad'" [required]="true"
                      [recovery]="true" [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Ciudad'"
                      [showClear]="true" (onClick)="openCitySelectionModal('origin')"
                      (valueChange)="clearCity('origin')">
                    </app-custom-inputgroup>
                    <app-custom-modal #selectCityOrigin [header]="'Selección de Ciudades'" [width]="'75vw'"
                      [output$]="outputCity$" [children]="componentCitySelection" [inputs$]="inputsForSelectCityModal$"
                      (selectedItems)="changeCity($event, 'origin')" hidden>
                    </app-custom-modal>
                  </div>
                  <div class="col field-department">
                    <app-custom-input-text [value]="departmentOrigin" [labelText]="'Departamento'" [disabled]="true">
                    </app-custom-input-text>
                  </div>
                </div>
              </p-fieldset>
            </div>
            <div class="col-lg-7 fieldset-freight">
              <p-fieldset legend="Destino">
                <div class="d-flex flex-wrap gap-1">
                  <div class="col field-city-destiny">
                    <app-custom-inputgroup [inputValue]="cityDestiny" [labelText]="'Ciudad'" [required]="true"
                      [recovery]="true" [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Ciudad'"
                      [showClear]="true" (onClick)="openCitySelectionModal('destiny')"
                      (valueChange)="clearCity('destiny')">
                    </app-custom-inputgroup>
                    <app-custom-modal #selectCityDestiny [header]="'Selección de Ciudades'" [width]="'75vw'"
                      [output$]="outputCity$" [children]="componentCitySelection" [inputs$]="inputsForSelectCityModal$"
                      hidden (selectedItems)="changeCity($event, 'destiny')">
                    </app-custom-modal>
                  </div>
                  <div class="col field-department">
                    <app-custom-input-text [value]="departmentDestiny" [labelText]="'Departamento'" [disabled]="true">
                    </app-custom-input-text>
                  </div>
                  <div class="col field-sectorId">
                    <app-custom-autocomplete formControlName="sectorId" [labelText]="'Sector'" [list]="listSectors"
                      [recovery]="true" (onChangeSelect)="changeSector($event)">
                    </app-custom-autocomplete>
                  </div>
                </div>
              </p-fieldset>
            </div>
            <div class="col field-conceptId">
              <app-custom-select formControlName="conceptId" [labelText]="'Tipo Vehículo'" [list]="listConcepts"
                [required]="true" [recovery]="true" (onChangeSelect)="changeConcept($event)">
              </app-custom-select>
            </div>
            <div class="col field-value">
              <app-custom-input-decimal formControlName="value" [labelText]="'Valor'"
                [required]="true"></app-custom-input-decimal>
            </div>
            <div class="col field-buttons">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>